import { IVendorUserListResponse } from "gql/CorporateValues/queries";
import { create } from "zustand";

interface UserState {
  dataAllUser: IVendorUserListResponse | undefined;
  loadingAllUser: boolean;
  errorAllUser: Error | null;
  setDataAllUser: (data: IVendorUserListResponse) => void;
  setLoadingAllUser: (loading: boolean) => void;
  setErrorAllUser: (error: Error | null) => void;
}

export const useAllUserStore = create<UserState>((set) => ({
  dataAllUser: undefined,
  loadingAllUser: false,
  errorAllUser: null,
  setDataAllUser: (data) => set({ dataAllUser: data }),
  setLoadingAllUser: (loading) => set({ loadingAllUser: loading }),
  setErrorAllUser: (error) => set({ errorAllUser: error }),
}));
